import { Phone, Mail, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        {/* Giant phone marquee */}
        <div className="mb-16">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#0055FF] mb-4">
            Membership set up by phone · mon–sun
          </div>
          <a
            href="tel:6185500625"
            data-testid="footer-giant-phone"
            className="block font-heading font-black uppercase tracking-tighter text-5xl sm:text-7xl lg:text-[9rem] leading-[0.85] text-white hover:text-[#0055FF] transition-colors"
          >
            (618) 550-0625
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-white/10 pt-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 flex items-center justify-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/47ayb25t_Screenshot%202026-04-14%20125312.png"
                  alt="JerseyFit Barbell logo"
                  className="w-full h-full object-contain"
                  style={{ filter: "invert(1)", mixBlendMode: "screen" }}
                />
              </div>
              <span className="font-heading font-extrabold tracking-tight text-xl uppercase">
                JerseyFit <span className="text-[#0055FF]">Barbell</span>
              </span>
            </div>
            <p className="mt-5 text-white/55 text-sm font-medium max-w-sm leading-relaxed">
              A strength training home where every lifter is welcome. Quality
              iron, honest pricing, real community.
            </p>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-4">
              Contact
            </div>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:6185500625"
                  data-testid="footer-phone-link"
                  className="inline-flex items-center gap-2 text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  <Phone size={14} /> (618) 550-0625
                </a>
              </li>
              <li>
                <a
                  href="mailto:jfbarbell@gmail.com"
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2 text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  <Mail size={14} /> jfbarbell@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/JerseyFitBarbell"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook-link"
                  className="inline-flex items-center gap-2 text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  <Facebook size={14} /> Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/jerseyfit_barbell/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="inline-flex items-center gap-2 text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  <Instagram size={14} /> Instagram
                </a>
              </li>
            </ul>
          </div>

          {/* Sections */}
          <div className="md:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-4">
              Explore
            </div>
            <ul className="space-y-3">
              <li>
                <a
                  href="#features"
                  data-testid="footer-nav-features"
                  className="text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  The Gym
                </a>
              </li>
              <li>
                <a
                  href="#training"
                  data-testid="footer-nav-training"
                  className="text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  Training
                </a>
              </li>
              <li>
                <a
                  href="#gallery"
                  data-testid="footer-nav-gallery"
                  className="text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  Photos
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  data-testid="footer-nav-pricing"
                  className="text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  Membership
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  data-testid="footer-nav-contact"
                  className="text-white/75 hover:text-white text-sm font-medium transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/40 font-medium">
            © {new Date().getFullYear()} JerseyFit Barbell. Built for lifters.
          </p>
          <p className="text-xs text-white/40 font-medium uppercase tracking-[0.2em]">
            Iron · Community · Integrity
          </p>
        </div>
      </div>
    </footer>
  );
}
